<ion-header>
  <ion-toolbar>
    <ion-title
      >Dokumenten zu
      {{ this.currentFolder()?.displayName }} hochladen</ion-title
    >
    <ion-buttons slot="end">
      <ion-button (click)="close()" [disabled]="uploadIsRunning">
        <ion-icon size="large" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content #modalContent>
  <div class="upload-section">
    @if(uploadIsRunning){
    <b
      >Upload läuft: {{ this.uploadCounter }} /
      {{ files.length }} hochgeladen</b
    >
    }@else if (failedUploads.length > 0){
    <div class="red">
      {{ files.length }} Dokumente konnten nicht hochgeladen werden. Bitte
      wiederholen!
    </div>
    }@else{
    <div>
      <span>{{ fileList?.length }} Dokumente ausgewählt</span>
      @if(invalidFileInfos?.length > 0){<span
        >, {{ invalidFileInfos?.length }} Fehler:</span
      >}
    </div>
    }

    <div *ngFor="let info of invalidFileInfos" class="errors red">
      {{ info }}
    </div>
    <div class="file-view" *ngFor="let item of files; let i = index">
      <ion-input
        labelPlacement="floating"
        fill="outline"
        mode="md"
        [(ngModel)]="item.displayName"
        [clearInput]="true"
      >
        <!--div slot="label">Dateiname</div-->
        <div slot="label" *ngIf="item.file != null">
          {{ tools.getDateString(item.file.lastModified) }} /
          {{ getFileSize(item.file.size) }} KB / {{ item.fileType }}
        </div>
        <div slot="label" *ngIf="item.blob != null">
          {{ tools.getDateString(null) }} / {{ getFileSize(item.blob.size) }} KB
          /
          {{ item.fileType }}
        </div>
      </ion-input>
      <ion-icon
        (click)="removeFile(i)"
        size="large"
        class="red"
        style="margin-left: 20px"
        name="trash-outline"
      ></ion-icon>
    </div>
  </div>
</ion-content>

<ion-footer>
  <ion-toolbar>
    <ion-button (click)="startUpload()" expand="block"
      ><ion-icon
        name="cloud-upload-outline"
        slot="start"
        class="white"
      ></ion-icon
      >Dokumente hochladen</ion-button
    >
  </ion-toolbar>
</ion-footer>
